import { cn } from "@/lib/utils";

export function ConstrainedContent({
  children,
  className,
  withSidebar = false,
  centered = true,
  wide = false,
}: {
  children: React.ReactNode;
  className?: string;
  withSidebar?: boolean;
  centered?: boolean;
  // AGENT: for dense work surfaces (workpapers) that need more room than the reading width.
  wide?: boolean;
}) {
  return (
    <div
      className={cn(
        "w-full", // fill available width
        wide ? "max-w-360" : "max-w-7xl",
        centered && "mx-auto",
        "px-4 sm:px-6 lg:px-8", // responsive padding
        "min-h-full", // full height of container
        withSidebar &&
          "lg:transition-[margin-left] lg:duration-200 lg:ease-linear", // align with header and footer when the sidebar is rendered
        withSidebar &&
          (wide
            ? "lg:ml-[max(0px,calc((100vw-90rem)/2-var(--sidebar-offset,0px)))]"
            : "lg:ml-[max(0px,calc((100vw-(var(--container-7xl)))/2-var(--sidebar-offset,0px)))]"),
        className,
      )}
    >
      {children}
    </div>
  );
}
